import { SkillStepType } from 'src/graphql/types'

export const skillTypeConverter = {
  [SkillStepType.Quiz]: 'Quiz',
  [SkillStepType.Coding]: 'Coding Challenge',
  [SkillStepType.CodeReview]: 'Code Review',
  [SkillStepType.Database]: 'Database',
}
